// Ensure category icons are in the Vite build (referenced dynamically via vite_asset_path)
import.meta.glob('../images/category_preset_icons/Icon-*-640.webp', { eager: true })
import.meta.glob('../images/category_preset_icons/icon-*-640.webp', { eager: true })

// Turbo Rails: loads @hotwired/turbo (which auto-starts), registers <turbo-cable-stream-source>
// for turbo_stream_from, and uses @rails/actioncable for the WebSocket consumer.
import "@hotwired/turbo-rails"

// Custom Turbo Stream actions
import '../utils/turbo_stream_custom_actions'

// Chartkick (admin analytics); exposes window.Chartkick for inline chart scripts
import '../utils/chartkick_setup'

// Swap favicons and manifest based on color scheme
import '../utils/theme_favicons'

// Import Stimulus
import { Application } from '@hotwired/stimulus'
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();


// Import all Stimulus controllers
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })

for (const path in controllers) {
  const module = controllers[path]
  const name = path
    .replace('../controllers/', '')
    .replace('_controller.js', '')
    .replace(/_/g, '-')
    .replace(/\//g, '--')

  if (module.default) {
    application.register(name, module.default)
  }
}
